import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)


const router = new VueRouter({
  routes
})

// 全局前置守卫
const whitelist = ['/login', '/register']
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const path = to.path
  if (whitelist.includes(path)) {
    next()
    return
  }
  if (token) next()
  else next('/login')
})
export default router
